import React, { useEffect, useState } from 'react';
import { platformService } from '@/services/platformService';
import { PlatformView } from '@/types/platform';
import DynamicPlatformView from './DynamicPlatformView.tsx';

interface PlatformViewLoaderProps {
  platformId: string;
}

const PlatformViewLoader: React.FC<PlatformViewLoaderProps> = ({ platformId }) => {
  const [platformView, setPlatformView] = useState<PlatformView | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadPlatformView = async () => {
      try {
        setLoading(true);
        setError(null);
        const raw = await platformService.getPlatformView(platformId);
        console.log('getPlatformView raw response:', raw);
        // Handle both direct PlatformView and ServiceResponse-wrapped responses
        const view: PlatformView = (raw as any).data ?? raw;
        if (!view?.viewConfig) {
          throw new Error('Invalid platform view response: missing viewConfig');
        }
        setPlatformView(view);
      } catch (err) {
        setError('Failed to load platform configuration');
        console.error('Error loading platform view:', err);
      } finally {
        setLoading(false);
      }
    };

    loadPlatformView();
  }, [platformId]);

  if (loading) {
    return (
      <div className="platform-loader">
        <p>Зареждане...</p>
      </div>
    );
  }

  if (error || !platformView) {
    return (
      <div className="platform-error">
        <p>{error || 'Грешка при зареждане на конфигурацията'}</p>
      </div>
    );
  }

  return <DynamicPlatformView platformView={platformView} />;
};

export default PlatformViewLoader;
